import { ResourceOptions } from 'react-admin';
import { FaCogs } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingSystemConfigs;
export const icon = FaCogs;
export const options: ResourceOptions = {
  label: 'module.socialTrading.systemConfigs',
};
